import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://pxawgcjaewtexomfxldt.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4YXdnY2phZXd0ZXhvbWZ4bGR0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQxMTk2NzIsImV4cCI6MjA1OTY5NTY3Mn0.s2flQfCsf5lAL5bj-iuL0030IEXl07ohqRiVM_kLxb0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey); 